module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/store_images/2@2x_3013e1527acf029cfbeee7fc85e7aad8.png";